import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isEqual, isEmpty } from 'lodash';
import { SessionStatus } from '@payer-admin-ui/components';
import { customerAPI } from './customerAPI';

export const filterableSessionStatuses = [
  SessionStatus.PENDING,
  SessionStatus.FAILED,
  SessionStatus.MANUAL_CONTROL,
  SessionStatus.ERROR,
  SessionStatus.COMPLETED,
];

export const fetchSessionsPage = createAsyncThunk('customers/sessions', async (_, { getState }) => {
  const { page, pageSize, appliedFilters } = getState().sessionsPage;

  const appliedFiltersWithDefaults = {
    ...appliedFilters,
    ...(isEmpty(appliedFilters.statuses) && { statuses: filterableSessionStatuses }),
  };

  let response = await customerAPI.getSessions({ page, pageSize, filters: appliedFiltersWithDefaults });

  return {
    sessions: response.contents,
    totalCount: response.totalCount,
  };
});

const emptyFilters = {
  statuses: [],
  creditResults: [],
};

const initialState = {
  error: null,
  sessions: [],
  totalCount: 0,
  page: 0, // zero-indexed in state, one-indexed in UI
  pageSize: 20, // hard-coded and can't be changed atm
  filters: emptyFilters,
  appliedFilters: emptyFilters,
};

const sessionsPageSlice = createSlice({
  name: 'sessionsPage',
  initialState,
  reducers: {
    resetError: (state, _) => ({ ...state, error: null }),
    setPage: (state, { payload: page }) => ({ ...state, page }),
    clearAllFilters: (state, _) => {
      if (!isEqual(state.filters, emptyFilters)) {
        state.filters = emptyFilters;
        state.appliedFilters = emptyFilters;
        state.page = 0;
      }
    },
    setFilter: (state, { payload: filterPatch }) => ({
      ...state,
      filters: { ...state.filters, ...filterPatch },
    }),
    applyFilters: (state, _) => {
      if (!isEqual(state.appliedFilters, state.filters)) {
        state.appliedFilters = state.filters;
        state.page = 0;
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchSessionsPage.pending, (state, _) => ({ ...state, error: null }));
    builder.addCase(fetchSessionsPage.fulfilled, (state, { payload }) => ({ ...state, ...payload }));
    builder.addCase(fetchSessionsPage.rejected, (state, { error }) => ({ ...state, error }));
  },
});

export const {
  actions: { resetError, setPage, clearAllFilters, applyFilters, setFilter },
  reducer: sessionsPageReducer,
} = sessionsPageSlice;
